export default __webpack_public_path__ + "static/call-me-photo-3b7eaace104ac48281c199cbebb1e3f0.png";